import React from 'react';
import Axios from 'axios';
import { History } from 'history';
import withTable, { TableContext } from '../../../hoc/withTable';
import Table from '../../../components/Table';
import TableFilterForm from '../../../forms/TableFilterForm';
import { InputDropdownCourse, InputDropDownTermYear } from '../../../elements';
import { API_URL } from '../../../../lib/const';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { PermissionContext } from '../../../../hoc/withPermission';
import consts from '../consts';

export const fetch = async (params : any = {'term_year': undefined }) => {
  if (!params.term_year) {
    params['term_year__current'] = true;
  }

  const response = await Axios.get(`${API_URL}/transfers/processes`, { params });
  return response.data;
};

type TransferProcessListPageProps = {
  onFilterChange: any,
  history: History,
}

const TransferProcessListPage = ({ onFilterChange, history }: TransferProcessListPageProps) => {

  const columns = [
    {
      Header: 'Nome',
      accessor: 'name',
      Cell: ({ value, original }: { value: string, original: any }) => {

        return (
          <PermissionContext.Consumer>
            {({ hasPermission }: { hasPermission: (permission: string) => boolean }) => hasPermission('transfers.change_transferprocess') ? (
              <Link style={{ overflow: 'visible', whiteSpace: 'normal' }}
                to={`/transferencias/processos/${original.id}`}
              >
                {value}
              </Link>
            ) : value}
          </PermissionContext.Consumer>
        );
      }
    },
    {
      Header: 'Curso',
      accessor: 'course.name',
    },
    {
      Header: 'Etapa x Ano',
      accessor: 'term_year.description',
    },
    {
      Header: 'Início',
      accessor: 'start_date',
      width: 150,
    },
    {
      Header: 'Termino',
      accessor: 'end_date',
      width: 150,
    },
    {
      Header: 'Ativo',
      accessor: 'active',
      width: 50,
      Cell: ({ value }: { value: boolean }) => {
        if (value) {
          return <FontAwesomeIcon icon="check" color="#6caa63" />
        }

        return <FontAwesomeIcon icon="xmark" color="#b77474" />;
      },
    },
    {
      Header: 'Ações',
      accessor: 'kind',
      width: 80,
      Cell: ({ original }: { original: any }) => (
        original.kind === consts.TransferProcessKind.CONVOCATION ? (
          <Link
            to={`/transferencias/processos/${original.id}/convocados`}
            title="Gerenciar convocação"
          >
            <FontAwesomeIcon icon="users" />
          </Link>
        ) : null
      ),
    },
  ];

  return (
    <section>
      <div className="list-base list-base-width" style={{ height: '100vh' }}>
        <TableFilterForm
          onFilterChange={onFilterChange}
          title="Processos de Transferência"
          defaultFilterFields={[{ name: 'name__icontains', label: 'Nome', col: 12 }]}
        >
          <InputDropdownCourse col="6" />
          <InputDropDownTermYear col="6" />
        </TableFilterForm>
        <TableContext.Consumer>
          {props => <Table columns={columns} {...props} />}
        </TableContext.Consumer>
        <PermissionContext.Consumer>
          {({ hasPermission }: { hasPermission: (permission: string) => boolean }) => hasPermission('transfers.add_transferprocess') && (
            <div>
              <button
                type="button"
                className="btn btn-primary mt-3"
                style={{ width: 'auto', float: 'right' }}
                onClick={() => history.push('/transferencias/processos/new')}>
                Criar processo
              </button>
            </div>
          )}
        </PermissionContext.Consumer>
      </div>
    </section>
  );
};

export default withTable(fetch)(TransferProcessListPage);
